import { useEffect } from "react";
import { connect } from "react-redux";
import { useQuery } from "react-query";
import { Button, Input, Checkbox } from "expano-components";
import { Main, Dashboard, PageLoader, Select } from "components";
import { getUser, updateUser } from "actions/users";
import { Field, reduxForm, SubmissionError } from "redux-form";
import { ReactComponent as UserIcon } from "icons/user.svg";
import getDepartmentsOptions from "utils/select_options/getDepartmentsOptions";

const InputField = (props) => <Input {...props} input={{ ...props.input }} />;
const CheckField = (props) => <Checkbox {...props} />;

const UserEdit = ({
  user,
  getUser,
  updateUser,
  pristine,
  handleSubmit,
  match: { params },
  history,
  change,
}) => {
  useEffect(() => {
    getUser(params.id);
  }, []);

  const { isFetching: is_fetching_departments, data: departments } = useQuery(
    "departments",
    getDepartmentsOptions
  );

  if (user.status === "invalid" || user.status === "loading")
    return <PageLoader />;

  if (user.status === "failure") {
    return <p>Error</p>;
  }

  const submit = async (values) => {
    try {
      await updateUser(params.id, values);
      history.push(`/users`);
    } catch (error) {
      throw new SubmissionError(error);
    }
  };

  return (
    <Main
      page={{
        name: "Edytuj użytkownika",
        icon: <UserIcon />,
        breadcrumbs: [
          { name: "Użytkownicy", path: "/users" },
          { name: "Edytuj użytkownika" },
        ],
      }}
    >
      <div className="dashboard-wrapper-flex">
        <div className="column-half">
          <Dashboard
            header={{
              title: "Podstawowe dane",
              icon: "info",
            }}
            footer={{
              buttons: (
                <>
                  <Button
                    type="cancel"
                    onClick={() => history.push("/users")}
                  />
                  <Button
                    key="submit"
                    disabled={pristine}
                    type="save"
                    onClick={handleSubmit(submit)}
                  />
                </>
              ),
            }}
          >
            <form noValidate onSubmit={handleSubmit(submit)}>
              <div className="dashboard__form__submit">
                <Field name="first_name" label="Imię" component={InputField} />
                <Field
                  name="last_name"
                  label="Nazwisko"
                  component={InputField}
                />
                <Field name="email" label="E-mail" component={InputField} />

                <Field
                  name="department_id"
                  type="hidden"
                  component={InputField}
                />
                <Select
                  options={departments}
                  isLoading={is_fetching_departments}
                  label="Dział"
                  defaultValue={
                    user?.data?.department
                      ? {
                          label: user?.data?.department?.name,
                          value: user?.data?.department?.id,
                        }
                      : {}
                  }
                  onChange={(value) => change("department_id", value)}
                />
                <Field
                  name="is_wrong_hours_alert_enabled"
                  label="Powiadamiaj o błędnych godzinach"
                  component={CheckField}
                />
                <Field
                  name="has_access_to_financial_reports"
                  label="Dostęp do raportów finansowych"
                  component={CheckField}
                />
                <Field
                  name="can_manage_remarks"
                  label="Może zarządzać uwagami"
                  component={CheckField}
                />
                <Field
                  name="is_active"
                  label="Aktywny"
                  component={CheckField}
                />
                <Field
                  name="password"
                  label="Hasło"
                  type="password"
                  component={InputField}
                />
                <Field
                  name="password_confirmation"
                  label="Powtórz hasło"
                  type="password"
                  component={InputField}
                />
              </div>
            </form>
          </Dashboard>
        </div>
      </div>
    </Main>
  );
};
const validate = (values) => {
  const errors = {};

  if (!values.first_name) {
    errors.first_name = "Imię jest wymagane";
  }

  if (!values.last_name) {
    errors.last_name = "Nazwisko jest wymagane";
  }

  if (!values.email) {
    errors.email = "E-mail jest wymagany";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
    errors.email = "Nieprawidłowy adres e-mail";
  }

  if (
    values.password &&
    values.password_confirmation &&
    values.password !== values.password_confirmation
  ) {
    errors.password_confirmation = "Hasła muszą być takie same";
  }

  return errors;
};

export default connect(
  ({ user }) => ({
    user,
    initialValues: {
      first_name: user?.data?.first_name,
      last_name: user?.data?.last_name,
      email: user?.data?.email,
      is_wrong_hours_alert_enabled: user?.data?.is_wrong_hours_alert_enabled,
      department_id: user?.data?.department_id,
      has_access_to_financial_reports:
        user?.data?.has_access_to_financial_reports,
      can_manage_remarks: user?.data?.can_manage_remarks,
      is_active: user?.data?.is_active,
    },
  }),
  (dispatch) => ({
    getUser: (id) => dispatch(getUser(id)),
    updateUser: (id, data) => dispatch(updateUser(id, data)),
  })
)(
  reduxForm({
    form: "edit-user",
    enableReinitialize: true,
    validate,
  })(UserEdit)
);
